import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@vwfs-bronson/bronson-react';
import { Container } from './Container';

export const StateRequestSubmitted = () => {
    const { t } = useTranslation('early-settlement');

    return (
        <Container title={t('dealer-callback.request-callback-section.submitted.title')}>
            <p className="u-mb-none">{t('dealer-callback.request-callback-section.submitted.text-line-1')}</p>
            <p className="u-mb-large">{t('dealer-callback.request-callback-section.submitted.text-line-2')}</p>

            <p className="u-mb-small">{t('dealer-callback.contact-us-section.text')}</p>
            <a href={t('dealer-callback.contact-us-section.link')}>
                <Button secondary id="contact-us-button" aria-label={t('dealer-callback.contact-us-section.button')}>
                    {t('dealer-callback.contact-us-section.button')}
                </Button>
            </a>
        </Container>
    );
};
